export function createSorter<T>(
    attribute: keyof T,
    type: 'date' | 'string',
    order: 'asc' | 'desc' = 'desc'
): (a: T, b: T) => number {
    if (type === 'date') {
        if (order === 'asc') {
            return (a: T, b: T) =>
                new Date(a[attribute] as string).getTime() - new Date(b[attribute] as string).getTime();
        } else {
            return (a: T, b: T) =>
                new Date(b[attribute] as string).getTime() - new Date(a[attribute] as string).getTime();
        }
    } else {
        if (order === 'asc') {
            return (a: T, b: T) => String(a[attribute]).localeCompare(String(b[attribute]));
        } else {
            return (a: T, b: T) => {
                return String(b[attribute]).localeCompare(String(a[attribute]));
            };
        }
    }
}
